

export default function SuccessCard() {

  return (
    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 space-y-6">
        <h2 className="text-3xl font-extrabold text-gray-900">Éxito</h2>
        <p>La dirección de entrega de tu paquete se ha confirmado correctamente.</p>
        <br />
        <i className="text-sm">(Ya puedes cerrar esta ventana)</i>
      </div>
    </div>
  )
}